import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface OrganizationsIconProps extends SvgIconProps {}

export const OrganizationsIcon = ({
  style,
  ...iconProps
}: OrganizationsIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="20.755"
      height="18.326"
      viewBox="0 0 20.755 18.326"
    >
      <g transform="translate(0.755)">
        <g
          transform="translate(2.935)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="3.876" cy="3.876" r="3.876" stroke="none" />
          <circle cx="3.876" cy="3.876" r="3.126" fill="none" />
        </g>
        <path
          d="M23.092,55.586c-.252-1.585-2.442-2.116-4-2.619a4.274,4.274,0,0,1-5.546,0c-1.563.5-3.753,1.034-4,2.619-.449,2.818,3.742,4.451,6.778,4.451s4.065-.59,4.065-.59"
          transform="translate(-9.503 -44.899)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <g transform="translate(6.377 3.189)">
          <g transform="translate(0 0)">
            <circle
              cx="3.876"
              cy="3.876"
              r="3.876"
              transform="translate(2.935)"
              fill="currentColor"
            />
            <path
              d="M23.092,55.586c-.252-1.585-2.442-2.116-4-2.619a4.274,4.274,0,0,1-5.546,0c-1.563.5-3.753,1.034-4,2.619-.449,2.818,3.742,4.451,6.778,4.451S23.541,58.4,23.092,55.586Z"
              transform="translate(-9.503 -44.899)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
